// Angular import
import { Component, Input } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// Project import
import { NavigationItem } from 'src/app/@theme/types/navigation';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  // public props
  @Input() item: NavigationItem;

  // Constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy
  ) {}

  // public method
  closeOtherMenu() {
    setTimeout(() => {
      const sections = document.querySelectorAll('.coded-hasmenu');
      for (let i = 0; i < sections.length; i++) {
        sections[i].classList.remove('active');
        sections[i].classList.remove('coded-trigger');
      }

      let current_url = this.location.path();
      const baseHref = this.locationStrategy.getBaseHref();
      if (baseHref) {
        current_url = baseHref + this.location.path();
      }
      const link = "a.nav-link[ href='" + current_url + "' ]";
      const ele = document.querySelector(link);
      if (ele !== null && ele !== undefined) {
        const parent = ele.parentElement;
        const up_parent = parent?.parentElement?.parentElement;
        const last_parent = up_parent?.parentElement;
        if (parent?.classList.contains('coded-hasmenu')) {
          parent.classList.add('active');
        } else if (up_parent?.classList.contains('coded-hasmenu')) {
          up_parent.classList.add('active');
        } else if (last_parent?.classList.contains('coded-hasmenu')) {
          last_parent.classList.add('active');
        }
      }
    }, 500);
  }
}
